import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { NotificationItem } from "@/lib/notification.api";
import {
  useDismissNotificationMutation,
  useMarkNotificationReadMutation,
} from "@/hooks/mutations/useNotificationMutations";

export function useNotificationActions() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<NotificationItem | null>(null);
  const markReadMutation = useMarkNotificationReadMutation();
  const dismissMutation = useDismissNotificationMutation();

  function openNotification(item: NotificationItem) {
    setSelected(item);
    if (!item.readAt) markReadMutation.mutate(item.id);
  }

  function followAction(item: NotificationItem) {
    if (!item.readAt) markReadMutation.mutate(item.id);
    if (item.actionUrl) navigate(item.actionUrl);
  }

  function closeDetail() {
    setSelected(null);
  }

  function dismissFromDetail(id: number) {
    dismissMutation.mutate(id, { onSuccess: closeDetail });
  }

  return {
    selected,
    openNotification,
    followAction,
    closeDetail,
    dismissMutation,
    dismissFromDetail,
  };
}
